export default "query professions{\n    professions\n}";